export const TREND_DATA_HEADING = "Today We Have";
export const HIGH_SEVERITY = "Anomalies";
export const MEDIUM_SEVERITY = "medium severity anomalies";
export const LOW_SEVERITY = "low severity anomalies";
export const ONGOING_INVESTIGATIONS = "Open Investigations";
